import React from 'react'

export const TopbarData = [
	{
		title: "Home",
		link: "/",
		key: "1"
	},
	//{
	//	title: "Resources",
	//	link: "/resources",
	//	key: "1"
	//},
	{
		title: "About Me",
		link: "/about",
		key: "1"
	},
	{
		title: "Projects & Links",
		link: "/projects",
		key: "1"
	},
	//{
	//	title: "How To Setup CSS Lan",
	//	link: "/lan/",
	//	key: "1"
	//},
	//{
	//	title: "CS:S Server Builder",
	//	link: "/builder/",
	//	key: "1"
	//},
	//{
	//	title: "FastDL",
	//	link: "/server/maps/.index.php",
	//	key: "1"
	//},
	{
		title: "Github",
		link: "https://github.com/log-ical",
		key: "2"
	},
	//{
	//	title: "Gamebanana",
	//	link: "https://gamebanana.com/members/1731795",
	//	key: "2"
	//}
]
